export class Permission {
  public id?: string;
  public name: string;
  public description: string;
}
